<template>
  <side-bar>
    <template slot="links">
      <sidebar-item v-for="item in filteredMenu" :key="item.name" :link="item" class="sidebar-item">
        <template v-if="item.children && item.children.length">
          <sidebar-item v-for="child in item.children" :key="child.name" :link="child" class="sidebar-subitem" />
        </template>
      </sidebar-item>
    </template>
  </side-bar>
</template>
<script>
export default {
  computed: {
    peranan() {
      const user = JSON.parse(localStorage.getItem("user"));
      return user && user.peranan ? user.peranan : "pengguna"; // Default to 'pengguna' if not found
    },
    menu() {
      return [
        // mula menu pengguna
        {
          name: "PROFIL PENGGUNA",
          path: "/profile",
          icon: "ni ni-single-02 text-yellow",
          role: "pengguna",
        },
        {
          name: "PENGURUSAN INISIATIF",
          icon: "ni ni-calendar-grid-58 text-blue",
          role: "pengguna",
          path: "/senarai-projek",
        },
        // tamat menu pengguna
        // mula menu pentadbir
        {
          name: "PROFIL PENGGUNA",
          path: "/profile",
          icon: "ni ni-single-02 text-yellow",
          role: "pentadbir",
        },
        {
          name: "PENGURUSAN INISIATIF",
          icon: "ni ni-calendar-grid-58 text-blue",
          role: "pentadbir",
          path: "/senarai-projek",
        },
        {
          name: "PENGURUSAN PENGGUNA",
          icon: "ni ni-settings-gear-65 text-primary",
          role: "pentadbir",
          path: "/user",
        },
        // tamat menu pentadbir
        // mula menu admin
        {
          name: "PROFIL PENGGUNA",
          path: "/profile",
          icon: "ni ni-single-02 text-yellow",
          role: "admin",
        },
        {
          name: "PENGURUSAN INISIATIF",
          path: "/senarai-projek",
          icon: "ni ni-calendar-grid-58 text-blue",
          role: "admin",
        },
        {
          name: "RUJUKAN PENILAIAN INISIATIF",
          icon: "ni ni-folder-17 text-blue",
          role: "admin",
          path: "/reference",
        },
        {
          name: "PENGURUSAN PENGGUNA",
          icon: "ni ni-settings-gear-65 text-primary",
          role: "admin",
          path: "/user",
        },
        // tamat menu admin
        // mula menu pentadbir awam
        {
          name: "PENGURUSAN INISIATIF",
          icon: "ni ni-calendar-grid-58 text-blue",
          role: "pentadbir awam",
          path: "/senarai-projek",
        },
        // tamat menu pentadbir awam
      ];
    },
    filteredMenu() {
      const menu = this.menu;
      if (this.peranan === "admin") {
        return menu
          .filter((item) => !item.role || item.role === "admin")
          .map((item) => {
            if (item.children) {
              item.children = item.children.filter(
                (child) => child.role === "admin"
              );
            }
            return item;
          });
      }
      if (this.peranan === "pentadbir") {
        return menu
          .filter((item) => !item.role || item.role === "pentadbir")
          .map((item) => {
            if (item.children) {
              item.children = item.children.filter(
                (child) => child.role === "pentadbir"
              );
            }
            return item;
          });
      }
      if (this.peranan === "pentadbir awam") {
        return menu
          .filter((item) => !item.role || item.role === "pentadbir")
          .map((item) => {
            if (item.children) {
              item.children = item.children.filter(
                (child) => child.role === "pentadbir"
              );
            }
            return item;
          });
      }
      // if (this.peranan === "pentadbir awam") {
      //   return menu
      //     .filter((item) => item.name === "PENGURUSAN INISIATIF" && item.role === "pentadbir awam")
      //     .map((item) => {
      //       if (item.children) {
      //         item.children = item.children.filter(
      //           (child) => child.role === "pentadbir awam"
      //         );
      //       }
      //       return item;
      //     });
      // }
      return menu
        .filter((item) => !item.role || item.role === "pengguna")
        .map((item) => {
          if (item.children) {
            item.children = item.children.filter(
              (child) => child.role === "pengguna"
            );
          }
          return item;
        });
    },
  },
};
</script>
<style scoped>
.sidebar-item {
  margin-bottom: 0.5rem;
}
.sidebar-item .nav-link {
  display: flex;
  align-items: center;
  padding: 0.75rem 1.5rem;
  font-size: 0.9rem;
  font-weight: 500;
  color: #2c3e50;
  border-radius: 8px;
  transition: all 0.3s ease;
}
.sidebar-item .nav-link:hover {
  background-color: #8eb8eed3;
  color: #003087;
  box-shadow: 0 2px 4px rgba(29, 26, 208, 0.807);
}
.sidebar-item .nav-link.active {
  background-color: #7ba7f0;
  /* Slightly different blue for active state */
  color: #001f5b;
  /* Darker blue text */
  box-shadow: 0 2px 6px rgba(29, 26, 208, 0.9);
  border-left: 4px solid #003087;
  /* Left border for emphasis */
}
.sidebar-subitem .nav-link {
  padding-left: 2.5rem;
  font-size: 0.85rem;
  font-weight: 400;
}
.sidebar-subitem .nav-link:hover {
  background-color: #e9ecef;
}
.sidebar-subitem .nav-link.active {
  background-color: #d3d9df;
  /* Slightly different for subitems */
  color: #001f5b;
  border-left: 4px solid #003087;
}
@media (max-width: 767.98px) {
  .sidebar-item .nav-link {
    padding: 1rem;
    font-size: 1rem;
  }
  .sidebar-subitem .nav-link {
    padding-left: 2rem;
    font-size: 0.95rem;
  }
}
</style>
